import { CountryCode, LanguageCode } from "@/types";

export const getCorporateSiteLocale = (
  countryCode: CountryCode,
  languageCode?: LanguageCode
): string | undefined => {
  switch (countryCode) {
    case "AE":
    case "BN":
    case "BT":
    case "BW":
    case "IE":
    case "IL":
    case "KW":
    case "MT":
    case "PH":
    case "QA":
    case "SA":
    case "TM":
    case "AU":
      return "en-AU";
    case "BR":
      return "pt-BR";
    case "CA":
      switch (languageCode) {
        case "fr":
          return "fr-CA";
        default:
          return "en-CA";
      }
    case "CH":
      switch (languageCode) {
        case "fr":
          return "fr-CH";
        case "it":
          return "it-CH";
        default:
          return "de-CH";
      }
    case "DE":
    case "AT":
    case "LI":
    case "LU":
      return "de-DE";
    case "ES":
    case "AD":
      return "es-ES";
    case "FR":
    case "BE":
    case "MC":
      return "fr-FR";
    case "GB":
      return "en-GB";
    case "HK":
      switch (languageCode) {
        case "en":
          return "en-HK";
        default:
          return "zh-HK";
      }
    case "IT":
    case "SM":
      return "it-IT";
    case "KR":
      return "ko-KR";
    case "JP":
      return "ja-JP";
    case "NL":
      return "nl-NL";
    case "PL":
      return "pl-PL";
    case "SG":
      return "en-SG";
    case "TW":
      return "zh-TW";
    case "US":
      return "en-US";
    case "AR":
    case "CL":
    case "CO":
    case "PE":
    case "PY":
      switch (languageCode) {
        case "pt":
          return "pt-LATAM";
        default:
          return "es-LATAM";
      }
  }
};
